import { ViewModel,View, ObservableArray } from "binder"
import { ChangeThemeMessage } from "../mainWindow/mainWindow-viewModel";
import { UserMainWindowViewModel } from "../userMainWindow/userMainWindow-viewModel";
import  { ThemeSelectorView } from "./themeSelector-view"

export class ThemeSelectorViewModel extends ViewModel{
    constructor(parentViewModel: UserMainWindowViewModel) {
        super(parentViewModel);
        this.typedParent = parentViewModel;
        this.fonts = ObservableArray.create<singleFont>();
        this.fonts.update(...[
            new singleFont(this,"1","IranSans"),
            new singleFont(this,"2","Yekan"),
            new singleFont(this,"3","Dana"),
        ]);
        if(document.body.classList.contains("yekan-font")){
            this.selectedFont = this.fonts[1];
        }else if(document.body.classList.contains("dana-font")){
            this.selectedFont = this.fonts[2];
        }else{
            this.selectedFont = this.fonts[0];
        }

    }
    GetDefaultView(): View <ViewModel> {
        return new ThemeSelectorView();
    }
    public getTypeId(): string {
        return "VM-4C8F3A62-3D3C-48BE-9C38-9176566BF6FF"
    }
    private typedParent : UserMainWindowViewModel;
    public set fonts(v: ObservableArray<singleFont>) { this._fonts = v; } public get fonts(): ObservableArray<singleFont> { return this._fonts;} private _fonts: ObservableArray<singleFont>;
    public set selectedFont(v: singleFont) { 
        let shallUpdateSelecctedFont = (this._selectedFont != null) && (v!=null);
        this._selectedFont = v; 
        if(shallUpdateSelecctedFont){
            this.setBackground("ignore");
        }
    } public get selectedFont(): singleFont { return this._selectedFont;} private _selectedFont: singleFont;
    
    setTheme1(){this.setBackground('1');}
    setTheme2(){this.setBackground('2');}
    setTheme3(){this.setBackground('3');}
    setTheme4(){this.setBackground('4');}
    setTheme5(){this.setBackground('5');}
    setTheme6(){this.setBackground('6');}
    setTheme7(){this.setBackground('7');}
    setTheme8(){this.setBackground('8');}
    setTheme9(){this.setBackground('9');}
    setTheme10(){this.setBackground('10');}
    setTheme11(){this.setBackground('11');}
    setTheme12(){this.setBackground('12');}
    setTheme13(){this.setBackground('13');}
    setTheme14(){this.setBackground('14');}
    setTheme15(){this.setBackground('15');}

    closeThemeWindow(){
        this.typedParent.closeThemeWindow();
    }

    setBackground(background:string){
        let msg = new ChangeThemeMessage()
        msg.background = background;
        msg.fontId = this.selectedFont.id;
        msg.shallSave = true;
        this.handleMessage(msg);
    }
}

export class singleFont extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel,id:string,name : string) {
        super(parent);
        this.id = id;
        this.name = name;
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
}